import { GoogleOAuthProvider } from '@react-oauth/google';

const GOOGLE_CLIENT_ID = '227102711386-167idjhcf6i1fhvhes2duj5npbupe4n8.apps.googleusercontent.com';

export const GoogleAuthProvider = ({ children }) => {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      {children}
    </GoogleOAuthProvider>
  );
};